<div class="d-flex flex-row">
  <div class="p-2 flex-grow-1">
    <span class="glyphicon cursor-pointer"
      [ngClass]="datasetListVisible ? 'icon-chevron-down' : 'icon-chevron-right'"
      (click)="datasetListVisible = !datasetListVisible"></span>
    <label class="ps-2 cursor-pointer" (click)="datasetListVisible = !datasetListVisible">{{getLabelInCurrentLang(factor.labels)}}</label>
  </div>
  <div class="p-2">{{(factor.weight * 100).toFixed(0)}}&nbsp;%</div>
</div>
<input type="range" class="form-range" [(ngModel)]="factor.weight" min="0"
  max="1.0" step="0.05">
<div [hidden]="!datasetListVisible">
  <div *ngFor="let dataset of factor.datasets">
    <pra-dataset-item [dataset]="dataset"></pra-dataset-item>
  </div>
</div>
